export const InitialState = {
    brand:[],
    images:[],
    user:false
}